export default __webpack_public_path__ + "static/css/App.e090a388.css";